import type { Mensagem } from '@/features/messaging';

import type { ConversasConhecidasDoCaso } from '../types/certificadoNegociacaoTypes';
import type { NegociacaoCasoTelefoneUi } from '../types/negociacaoDetailTypes';
import { getMensagemCaseId } from './negociacaoDetailUiUtils';

export const idsDasConversasDaFila = (telefones: NegociacaoCasoTelefoneUi[]): string[] =>
  telefones.flatMap(({ conversaId }) => (conversaId ? [conversaId] : []));

/**
 * A mensagem que o tempo real entregou é do caso quando o produtor a ligou a ele
 * (`metadata.caseId`) ou, sem esse vínculo, quando chegou numa conversa do caso, inclusive a de um
 * número antigo da fila. Vínculo explícito com OUTRO caso vence a conversa: numa conversa
 * reaproveitada, a mensagem de outro caso não muda este certificado. A atualização de status só
 * traz a conversa.
 */
export function mensagemEhDoCaso(
  mensagem: Mensagem | Pick<Mensagem, 'conversaId'>,
  { casoId, conversaIds }: ConversasConhecidasDoCaso,
): boolean {
  const casoExplicito = 'metadata' in mensagem ? getMensagemCaseId(mensagem) : null;
  if (casoExplicito) return casoExplicito === casoId;
  return conversaIds.includes(mensagem.conversaId);
}
